import { useTranslation } from 'react-i18next';
import { useStorage } from '../../hooks/use-storage';
import { useSwal } from '../../hooks/use-swal';
import { layoutDefaults } from '../../utils/layout-defaults';
import { useAnalytics } from '../../utils/setup/analytics-setup';

function usePaymentCardDeletedModal() {
  const storage = useStorage();
  const { t } = useTranslation();
  const { analyticsPageView } = useAnalytics();
  const { swal } = useSwal({ storage, includesTitleBottomMargin: true });

  function didOpen() {
    analyticsPageView('Payment Card Deleted');
  }

  async function show() {
    const modalResult = await swal.fire({
      title: t('payment-card-deleted-modal.title'),
      icon: 'success',
      timer: layoutDefaults.modalTimer,
      didOpen,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: false,
    });

    return modalResult;
  }

  return {
    showPaymentCardDeletedModal: show,
  };
}

export { usePaymentCardDeletedModal };
